module.exports = __webpack_public_path__ + "img/diamond_bonus-zh.7b9fea6a.png";